
import { APIData } from '../constants';
import useRest from './base/useRest';

// Stripe


const preffix = "user-subscriptions";

export const useUserSubscriptions = (options?: APIData) => {
    return useRest(`${preffix}`, options);
};

export const useUserSubscriptionsManageURL = (options?: APIData) => {
    return useRest(`${preffix}/manage-url`, options);
};